/* Blog: búsqueda en cliente sobre títulos y resúmenes (como el React); sin JS se ven todos los artículos. */
(() => {
  const root = document.querySelector('[data-blog]');
  const input = document.getElementById('blog-search');
  if (!root || !input) return;
  const empty = root.querySelector('[data-blog-empty]');
  const term = root.querySelector('[data-blog-term]');
  const fold = (s) => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const cards = [...root.querySelectorAll('[data-blog-card]')];
  input.addEventListener('input', () => {
    const q = fold(input.value.trim().toLowerCase());
    let shown = 0;
    cards.forEach((card) => {
      const match = !q || fold(card.dataset.search).includes(q);
      (card.closest('[data-reveal-item]') ?? card).hidden = !match;
      if (match) shown++;
    });
    empty.hidden = shown > 0;
    term.textContent = `"${input.value.trim()}"`;
  });
})();
